import BaseValidator from 'services/validations/base-validator';

class CheckedAtLeastOneCombinationValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const items = stacking.getItems();

        items.forEach((item) => {
            if (item.isSecondaryStackTypeNone()) {
                return;
            }

            const combinations = item.getSecondaryStackCombinations();
            for (let key in combinations) {
                if (combinations[key]) {
                    return;
                }
            }

            this.addError('Secondary stack has to have at least 1 checked point.');
        });
    }
}

export default CheckedAtLeastOneCombinationValidator;
